/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import { Button, Form } from "antd";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import ReportExcelBtn from "../../components/ReportExcelBtn";


class CreditTerminals extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            valueSearch: "",
            modalFilter: false,
            modalFilterPos: "",
            filterPos: "",
        };

        this.id = "CREDIT_TERMINALS";

        this.api = {
            get: "get_credit_terminals"
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22582);
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        let sorter = true;
        let render = t => t;

        const columns = [
            { title: gt(22583), key: "pBranchID", dataIndex: "pBranchID", width: 100, render },
            { title: gt(22584), key: "pBranchName", dataIndex: "pBranchName", width: 150, render },
            { title: gt(22585), key: "pID", dataIndex: "pID", width: 100, render },
            { title: gt(22586), key: "pName", dataIndex: "pName", width: 150, render },
            { title: gt(22587), key: "pShvaUserName", dataIndex: "pShvaUserName", width: 150, render },
            { title: gt(22588), key: "pShvaPassword", dataIndex: "pShvaPassword", width: 150, render },
            { title: gt(22589), key: "pShvaMerchant", dataIndex: "pShvaMerchant", width: 150, render },
            { title: gt(22590), key: "pPinpadDangotCode", dataIndex: "pPinpadDangotCode", width: 150, render },
            { title: gt(22591), key: "pPinpadDangotSerial", dataIndex: "pPinpadDangotSerial", width: 150, render },
            { title: gt(22592), key: "pPinpadDangotIP", dataIndex: "pPinpadDangotIP", width: 150, render },
            { title: gt(22593), key: "pHypIP", dataIndex: "pHypIP", width: 150, render },
            { title: gt(22594), key: "pHypIPSwitch", dataIndex: "pHypIPSwitch", width: 150, render },
            { title: gt(22595), key: "pHypTerminalId", dataIndex: "pHypTerminalId", width: 150, render },
            { title: gt(22596), key: "pCardcomTerminalNumber", dataIndex: "pCardcomTerminalNumber", width: 150, render },
            { title: gt(22597), key: "pCardcomTerminalUsername", dataIndex: "pCardcomTerminalUsername", width: 200, render }
        ];

        let excelDataset = [columns.map(c => c.title)];
        this.props.data[this.id].data.forEach(d => {
            const [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14, c15] = d.split("\f")
            if (this.state.filterPos && !this.state.filterPos.split(",").find(p => p === c1)) return;
            if (this.state.valueSearch && d.indexOf(this.state.valueSearch) === -1) return;
            excelDataset.push([c3, c4, c1, c2, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14, c15])
        });

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(22582)}
                filterButton={() => { this.setState({ modalFilter: true }) }}
                rowsFilter={x => this.state.filterPos ? this.state.filterPos.split(",").includes(x.pID) : true}
                searchBox
                filterDatasetText={this.state.valueSearch}
                valueSearch={this.state.valueSearch}
                onChangeSearch={value => this.setState({ valueSearch: value.target.value })}
                scroll={{ y: window.innerHeight - 250, x: window.innerWidth - 100 }}
                columns={columns}
                genericActionButtons={[
                    <ReportExcelBtn
                        {...this.props}
                        btnStyle
                        tooltip={this.getText(11180)}
                        reportName={"Terminals"}
                        excelDataset={[{ name: "Terminals", data: excelDataset }]}
                    />
                ]}
            />
            <GenericModal
                visible={this.state.modalFilter}
                onCancel={() => { this.setState({ modalFilter: false }) }}
                title={gt(22598)}
                width={400}
                footer={[
                    <Button key="close" onClick={() => {
                        this.setState({ modalFilter: false, modalFilterPos: this.state.filterPos })
                    }}>{gt(22600)}</Button>,
                    <Button key="clear" onClick={() => {
                        this.setState({ modalFilterPos: "" })
                    }}>{gt(22601)}</Button>,
                    <Button type="primary" key="filter" onClick={() => {
                        this.setState({ modalFilter: false, filterPos: this.state.modalFilterPos })
                    }}>{gt(22602)}</Button>,
                ]}>
                <Form.Item label={gt(22599)}>
                    <GenericSelectorPosStorages
                        {...this.props} multi
                        value={this.state.modalFilterPos ? this.state.modalFilterPos.split(",") : []}
                        onChange={value => this.setState({ modalFilterPos: value ? value.join(",") : "" })}
                    />
                </Form.Item>

            </GenericModal>
        </div>)
    }

}

export default CreditTerminals;